/* ============================================================
   AGE GATE
   ============================================================ */
function enterSite() {
  const gate = document.getElementById('ageGate');
  if (!gate) return;
  sessionStorage.setItem('ageVerified', '1');
  gate.style.transition = 'opacity 0.5s';
  gate.style.opacity = '0';
  setTimeout(() => { gate.style.display = 'none'; }, 500);
}

(function () {
  if (sessionStorage.getItem('ageVerified') === '1') {
    const gate = document.getElementById('ageGate');
    if (gate) gate.style.display = 'none';
  }
})();


/* ============================================================
   COOKIE BANNER
   ============================================================ */
function acceptCookies() {
  localStorage.setItem('cookiesAccepted', '1');
  document.getElementById('cookieBanner').style.display = 'none';
}

(function () {
  if (localStorage.getItem('cookiesAccepted') !== '1') {
    const banner = document.getElementById('cookieBanner');
    if (banner) banner.style.display = 'flex';
  }
})();


/* ============================================================
   MOBILE MENU
   ============================================================ */
function toggleMenu() {
  const m = document.getElementById('mobileMenu');
  const b = document.getElementById('navHamburger');
  if (!m) return;
  m.classList.toggle('open');
  if (b) b.setAttribute('aria-expanded', m.classList.contains('open'));
}


/* ============================================================
   NAV — DARK / LIGHT THEME ON SCROLL
   ============================================================ */
(function () {
  const nav = document.getElementById('mainNav');
  if (!nav) return;

  const sections = document.querySelectorAll('[data-theme]');

  function updateNav() {
    const scrollY = window.scrollY + 80;
    let onDark = false;
    sections.forEach(s => {
      const top = s.offsetTop;
      const bottom = top + s.offsetHeight;
      if (scrollY >= top && scrollY < bottom && s.dataset.theme === 'dark') {
        onDark = true;
      }
    });
    nav.classList.toggle('on-dark', onDark);
  }

  window.addEventListener('scroll', updateNav);
  updateNav();
})();


/* ============================================================
   SCROLL REVEAL
   ============================================================ */
(function () {
  const reveals = document.querySelectorAll('.reveal');
  if (!reveals.length) return;

  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('visible');
    });
  }, { threshold: 0.1 });

  reveals.forEach(el => obs.observe(el));
})();


/* ============================================================
   FIND PAGE — MAP & LOCATIONS
   Note: requires Leaflet. Load leaflet.js BEFORE this file:
   <script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"></script>
   ============================================================ */
(function () {
  const mapContainer = document.getElementById('mapContainer');
  if (!mapContainer) return; // only runs on the find page

  const locations = [
    { name: 'Bibi London',       address: '42 North Audley Street',    city: 'London',                  postcode: 'W1K 6ZP',  type: 'restaurant',  lat: 51.5124, lng: -0.1534 },
    { name: 'Saros',             address: '12 Moat Street',            city: 'Bridgnorth',              postcode: 'WV16 4EP', type: 'restaurant',  lat: 52.5344, lng: -2.4197 },
    { name: 'Five Rivers',       address: '11 Vicarage Place',         city: 'Walsall',                 postcode: 'WS1 3NA',  type: 'restaurant',  lat: 52.5811, lng: -1.9831 },
    { name: "Uday's",            address: '381 Dudley Road',           city: 'Wolverhampton',           postcode: 'WV2 3AY',  type: 'restaurant',  lat: 52.5721, lng: -2.1358 },
    { name: 'Dosa Hut',          address: '314 Dudley Road',           city: 'Wolverhampton',           postcode: 'WV2 3JY',  type: 'restaurant',  lat: 52.5737, lng: -2.1323 },
    { name: 'Simla',             address: '42 Beatrice Street',        city: 'Oswestry',                postcode: 'SY11 1QG', type: 'restaurant',  lat: 52.8591, lng: -3.0544 },
    { name: "Jack's Bar",        address: 'Frederick Street',          city: 'Wolverhampton',           postcode: 'WV2 4DU',  type: 'bar',         lat: 52.5788, lng: -2.1274 },
    { name: 'Red Lion',          address: '190 All Saints Way',        city: 'West Bromwich',           postcode: 'B71 1RH',  type: 'bar',         lat: 52.5323, lng: -1.9876 },
    { name: 'Linthouse Wines',   address: '1 Linthouse Lane',          city: 'Wolverhampton',           postcode: 'WV11 3EA', type: 'off-licence', lat: 52.6138, lng: -2.0892 },
    { name: 'Liquor Outlet',     address: '401 Walsall Road',          city: 'Perry Barr, Birmingham',  postcode: 'B42 1BT',  type: 'off-licence', lat: 52.5196, lng: -1.9030 },
    { name: 'Taj Mahal',         address: '29 Bridge Road, Wellington',city: 'Telford',                 postcode: 'TF1 1ED',  type: 'restaurant',  lat: 52.7010, lng: -2.5155 },
    { name: 'Shapla',            address: '58 Broad Street',           city: 'Ludlow',                  postcode: 'SY8 1NH',  type: 'restaurant',  lat: 52.3681, lng: -2.7154 },
    { name: 'Milan Lounge',      address: 'Wolverhampton Road',        city: 'Shifnal',                 postcode: 'TF11 9EZ', type: 'restaurant',  lat: 52.6679, lng: -2.3699 },
    { name: 'Drinkstop',         address: '13 The Parade, Donnington', city: 'Telford',                 postcode: 'TF2 8EQ',  type: 'off-licence', lat: 52.7073, lng: -2.4197 },
    { name: 'Compton Wineseller',address: '47 Bridgnorth Road',        city: 'Wolverhampton',           postcode: 'WV6 8AF',  type: 'off-licence', lat: 52.5867, lng: -2.1757 },
    { name: 'Glassy Junction',   address: '131 Willenhall Road',       city: 'Wolverhampton',           postcode: 'WV1 2HR',  type: 'bar',         lat: 52.5840, lng: -2.1143 },
    { name: 'Royal Oak',         address: '171 Holyhead Road',         city: 'Birmingham',              postcode: 'B21 0BD',  type: 'bar',         lat: 52.5020, lng: -1.9484 },
    { name: 'Tiffin Tree',       address: '71 Vane Street, Vincent Square', city: 'London',            postcode: 'SW1P 2PA', type: 'restaurant',  lat: 51.4951, lng: -0.1358 },
    { name: 'Morni',             address: '18A Oswald Road',           city: 'Oswestry',                postcode: 'SY11 1RE', type: 'restaurant',  lat: 52.8603, lng: -3.0561 },
  ];

  let map, markers = [], filtered = [...locations];
  let orangeIcon;

  window.addEventListener('load', () => {
    map = L.map('mapContainer').setView([52.5, -1.8], 6);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; OpenStreetMap &copy; CARTO',
      maxZoom: 19,
    }).addTo(map);

    orangeIcon = L.divIcon({
      html: '<div style="width:14px;height:14px;background:#e94e1b;border:2px solid #412512;border-radius:50%"></div>',
      className: '',
      iconSize: [14, 14],
      iconAnchor: [7, 7],
    });

    renderAll();
  });

  function renderAll() {
    markers.forEach(m => m.remove());
    markers = [];

    const list = document.getElementById('locationList');
    if (!list) return;
    list.innerHTML = '';

    filtered.forEach((loc, i) => {
      const m = L.marker([loc.lat, loc.lng], { icon: orangeIcon })
        .addTo(map)
        .bindPopup(
          `<strong style="font-family:Archivo,sans-serif;font-size:0.82rem">${loc.name}</strong>` +
          `<br><span style="font-size:0.75rem;color:#666">${loc.address}, ${loc.city}</span>`
        );
      markers.push(m);

      const div = document.createElement('div');
      div.className = 'find-item' + (i === 0 ? ' active' : '');
      div.innerHTML =
        `<h3>${loc.name}</h3>` +
        `<p>${loc.address}<br>${loc.city} ${loc.postcode}</p>` +
        `<span class="find-type">${loc.type}</span>`;

      div.addEventListener('click', () => {
        document.querySelectorAll('.find-item').forEach(el => el.classList.remove('active'));
        div.classList.add('active');
        map.setView([loc.lat, loc.lng], 14);
        m.openPopup();
      });

      list.appendChild(div);
    });

    if (filtered.length > 0) {
      const group = L.featureGroup(markers);
      map.fitBounds(group.getBounds().pad(0.2));
    }
  }

  function filterLocations() {
    const q = document.getElementById('searchInput').value.toLowerCase();
    const t = document.getElementById('typeFilter').value;

    filtered = locations.filter(l => {
      const matchQ = !q ||
        l.name.toLowerCase().includes(q) ||
        l.city.toLowerCase().includes(q) ||
        l.postcode.toLowerCase().includes(q);
      const matchT = t === 'all' || l.type === t;
      return matchQ && matchT;
    });

    renderAll();
  }

  const searchInput = document.getElementById('searchInput');
  if (searchInput) {
    searchInput.addEventListener('keyup', e => {
      if (e.key === 'Enter') filterLocations();
    });
  }

  // Expose to inline onclick handlers in HTML (e.g. search button)
  window.filterLocations = filterLocations;
})();